import { useTranslation } from "react-i18next"
import AsideFilterWrapper from "../../../../../../../commons/aside-filter-wrapper"
import Flex from "../../../../../../../commons/Flex"
import { useFilters } from "../../../../../../../contexts/FiltersContext"

const FilterCategoryHotel = ({ data }) => {
  const { t } = useTranslation("translations")
  const { filters, handleFilters } = useFilters()

  return (
    <AsideFilterWrapper title={t("filters.categoryHotel")}>
      <Flex className="aside-filters__options">
        {[1, 2, 3, 4, 5].map((hotelCategory) => (
          <Flex
            key={hotelCategory}
            className={`aside-filters__option-btn${
              !data.includes(hotelCategory) ? " disabled" : ""
            }${
              filters?.hotelCategory?.value == hotelCategory ? " selected" : ""
            }`}
            onClick={
              !data.includes(hotelCategory)
                ? undefined
                : () => {
                    handleFilters(
                      "hotelCategory",
                      filters?.hotelCategory?.value === hotelCategory
                        ? undefined
                        : hotelCategory
                    )
                  }
            }
          >
            <span>{hotelCategory}</span>
            <i className="fa fa-star" />
          </Flex>
        ))}
      </Flex>
    </AsideFilterWrapper>
  )
}

export default FilterCategoryHotel
